export enum LIMIT {
  DESKTOP_SIDENAV = 8,
  DESKTOP_NO_SIDENAV = 10,
  MOBILE_TABLET = 6,
}

export enum PLP_TYPE {
  CATEGORY = 'categories',
  SOLUTION = 'solutions',
  BRAND = 'brands',
}

export enum SEARCH_MODE {
  LEXICAL = 'LEXICAL',
  NEURAL = 'NEURAL',
  HYBRID = 'HYBRID',
}

export enum Width {
  DESKTOP = 249.6,
  DESKTOP_FACETS = 232.5,
  TABLET = 224,
  MOBILE = 163.5,
}

export enum Gap {
  DESKTOP = 24,
  TABLET = 16,
  MOBILE = TABLET,
}
